/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnExecutionResource} from './execution-resource.resource';

/** Angular DI token for the ReportExecution HTTP resource (factory product). */
export class ReportExecutionResource {
}

export function createReportExecutionResource(adnExecutionResource: any): any {
  const ReportExecution = adnExecutionResource('reports');
  ReportExecution.start = function(params: any): Promise<any> {
    return ReportExecution.$start(params);
  };
  return ReportExecution;
}

export const reportExecutionResourceProvider = {
  provide: ReportExecutionResource,
  useFactory: createReportExecutionResource,
  deps: [AdnExecutionResource]
};

